import React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Button,Modal,Container,
   Divider, IconButton, Input, InputAdornment, List, ListItem, ListItemIcon, MenuItem, Paper, Select, Stack, Switch, Pagination, Tooltip, Typography } from '@mui/material';
import CloseButton from './CloseButton';
import { EmailSharp, Favorite } from '@mui/icons-material';

const ListenerInfoModal = ({listener,listenerModalOpen, setListenerModalOpen}) => {
  const l = listener
  const playsMap =(listen)=>{

    return 
  }
  const listenMap =l?.listens?.map((t,i)=>{
 if( t?.title ){

   return (
     <span key={i}
     style={{display:'flex',
       alignContent: 'center'
     }}
     >
       {t?.title} - {t?.plays?.length} {listener?.likes?.includes(t?.track)? <Favorite/>:' '}
     </span>
   )
 }
  })

  const sumTotalShares = () =>{
    let shareCount = 0
    l?.shares?.forEach(s=>{
      shareCount += s?.emails?.length
    })
    return shareCount
  }
const totalShares = sumTotalShares()
  return (
    <>
    <Modal 
        open={listenerModalOpen}
        onClose={()=>setListenerModalOpen(!listenerModalOpen)}
        >
        <Container sx={{zIndex:999}}>
            <Box sx={{ 
                display:'flex',
                flexDirection:'column',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                height:'100%',
                backgroundColor:  'rgba( 0, 0, 0, 0.1)',
                backdropFilter:'blur(10px)',
                borderRadius:'10px',
                border:'2px solid #000',
                fontFamily: 'Gilroy, sans-serif',
                justifyContent:'center',
                textAlign:'center',
                alignItems:'center',
                gap:'0.5rem',
                padding:'0.5rem',
                color:'#FFF',
                
                }}>
                    <Box sx={{position:'absolute', top:'0.5rem', right:'0.5rem'}}>
                        <CloseButton func={setListenerModalOpen} val={listenerModalOpen}
                        />
                    </Box>
                     <Box sx={{
                        position:'relative',
                            display:'flex',flexDirection:'column', 
                            backgroundImage: 'url("/assets/BodyBG2.png")',
                            // backgroundImage:'url("/assets/Gradient_01_Frame2.png")',
                            backgroundAttachment: 'cover',
                            backgroundRepeat: 'no-repeat',
                            // background:'#000',
                            boxShadow:'0 0 10px 5px rgba(0, 255, 0 ,0.5)',
                            overflow:'hidden',overflowY:'scroll',
                            width:'80%', maxWidth:'600px',
                            minWidth:'340px', minHeight:'550px', gap:'0.5rem', color:'#00FF00', borderRadius:'5px'}}>
                        <Box sx={{position:'sticky',top:0, left:0, zIndex:999999999,width:'100%', height:'1.5rem',background:'#F6F6F6'}}>
                     
                            <Typography sx={{color: '#858585'}} className='blink'>
                               <b>Listener Details</b> 
                            </Typography>
                            </Box>
                  
                    <Stack 
                     className='center'
                     sx={{position:'relative',
                        height:'100%',width:'100%',
                        padding:'0.5rem',
                        // flex:1
                            margin:'auto', 
                            gap:'0.5rem',
                            color:'#FFF'
                        }} >
<h3>{l?.email}</h3>
<h2>{l?.preferredName}</h2>
<Box sx={{width:'100%', display:'flex', gap:'0.5rem',padding:'0.5rem'}}>

  <Stack sx={{gap:'0.5rem', 
    width:'60%',
    padding:'0.5rem', maxHeight:'300px', overflowY:'scroll'}}>
  {listenMap}
  </Stack>
  <Stack sx={{padding:'0.5rem'}}>
  <span>{l?.subscriptions[0]?.title}</span> 
  <span>shares: {totalShares}</span> 
  <span>coins: {l?.wallet?.coins}</span> 
  </Stack>
</Box>

                    </Stack>
                   
              </Box>
                </Box>                   
        </Container>
    </Modal>
    
</>
  )
}

export default ListenerInfoModal